import { RouteObject } from 'react-router-dom';
import TermsPage from '../components/Terms';
import { acceptUserinvitationFlow, verifyUserFlow } from '../helpers';
import HubInviteRedirect from './HubInviteRedirect';
import SigninCallback from './SigninCallback';
import SignoutCallback from './SignoutCallback';

const routes: RouteObject[] = [
  {
    path: '/signin-callback',
    element: <SigninCallback />,
  },
  {
    path: '/signout-callback',
    element: <SignoutCallback />,
  },
  {
    path: '/redirect',
    children: [
      {
        path: 'accept-hub-invite/:id',
        element: <HubInviteRedirect redirect={acceptUserinvitationFlow} />,
      },
      {
        path: 'verify-hub-invite/:id',
        element: <HubInviteRedirect redirect={verifyUserFlow} />,
      },
    ],
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
];
export default routes;
